import { pascalCase } from 'change-case';
import Butterfly from './butterfly-50.svg';
import Camel from './camel-50.svg';
import Cat from './cat-50.svg';
import Caterpillar from './caterpillar-50.svg';
import Chinchilla from './chinchilla-50.svg';
import Crab from './crab-50.svg';
import Dog from './dog-50.svg';
import Dolphin from './dolphin-50.svg';
import Duck from './duck-50.svg';
import Elephant from './elephant-50.svg';
import Flamingo from './flamingo-50.svg';
import Giraffe from './giraffe-50.svg';
import Gorilla from './gorilla-50.svg';
import Grasshopper from './grasshopper-50.svg';
import Hedgehog from './hedgehog-50.svg';
import Horse from './horse-50.svg';
import Kangaroo from './kangaroo-50.svg';
import Pig from './pig-50.svg';
import Seal from './seal-50.svg';
import Sheep from './sheep-50.svg';
import Swan from './swan-50.svg';
import Toucan from './toucan-50.svg';
import Turtle from './turtle-50.svg';
import Unicorn from './unicorn-50.svg';
import Walrus from './walrus-50.svg';
import Whale from './whale-50.svg';

export const GuestAvatars = {
    Butterfly,
    Camel,
    Cat,
    Caterpillar,
    Chinchilla,
    Crab,
    Dog,
    Dolphin,
    Duck,
    Elephant,
    Flamingo,
    Giraffe,
    Gorilla,
    Grasshopper,
    Hedgehog,
    Horse,
    Kangaroo,
    Pig,
    Seal,
    Sheep,
    Swan,
    Toucan,
    Turtle,
    Unicorn,
    Walrus,
    Whale,
    lookup(src: string) {
        const key = pascalCase(src.replace('deqo://icons/i8/', ''));
        return GuestAvatars[key] ?? null;
    }
};
